import styles from '../../styles/PodcastPlaylist.module.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
import Image from 'next/image';

const PodcastPlayList = ({ data, onSelectChannel }) => {

    return (
        <Col>
            <div className={styles.playlistHolder}>
                <div className={styles.playlistHeader}>信息系列</div>
                <div className={styles.relatedDivider}></div>
                {
                    data == null ? <></> : data.map(function (item, index) {
                        return (
                            <div key={item.id} className={styles.playlistRow} onClick={() => onSelectChannel(index)}>
                                <Container fluid>
                                    <Row>
                                        <Col lg={3} style={{ height: '65px' }}>
                                            <Image
                                                src={item.image}
                                                alt="信息分類"
                                                sizes="100vw"
                                                height={0}
                                                width={0}
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                }}
                                            />
                                        </Col>
                                        <Col lg={7} className='col align-self-center' >
                                            <Row><span className={styles.playlistTitle}>{item.title}</span></Row>
                                        </Col>
                                        <Col lg={2} className='col align-self-center'>
                                            <Row><span className={styles.playlistCount}>{item.num} 篇</span></Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        )
                    })
                }
            </div>
        </Col>
    );
}

export default PodcastPlayList;